export default __webpack_public_path__ + "static/css-entertainment-logo-white-a76e29017e7a550fadac642d95554013.png";